<template>
  <section id="institutes" class="">
    <div class="institutes-wrapper">
      <template v-for="(item, i) in ins" :key="i">
        <div class="d-inline-flex institutes-unit flex-column">
          <div class="text-start small-text w-100 d-none d-md-block">
            {{ item.nation }}
          </div>
          <Institute :info="item" class="d-none d-sm-block"></Institute>
          <InstituteM :info="item" class="d-sm-none"></InstituteM>
        </div>
      </template>
    </div>
    <div class="arrows text-end d-flex justify-content-end">
      <button class="flex-center scroll-btn scroll-left">
        <img :src="arrowLeft" alt="" />
      </button>
      <button class="flex-center scroll-btn scroll-right">
        <img :src="arrowRight" alt="" />
      </button>
    </div>
  </section>
</template>

<script>
import 'overlayscrollbars/css/OverlayScrollbars.min.css';
import OverlayScrollbars from 'overlayscrollbars/js/OverlayScrollbars.min';

import linkArrow from '@/assets/img/link_arrow.png';
import arrowLeft from '@/assets/img/arrow-left.svg';
import arrowRight from '@/assets/img/arrow-right.svg';
import y1 from '@/assets/img/y1.png';
import y2 from '@/assets/img/y2.png';
import y3 from '@/assets/img/y3.png';
import y4 from '@/assets/img/y4.png';
import y5 from '@/assets/img/y5.png';
import Institute from '@/components/about/Institute.vue';
import InstituteM from '@/components/about/InstituteM.vue';

// api
import { getInstituteList } from '@/api/institute';

export default {
  name: 'InstitutePage',
  components: { Institute, InstituteM },
  data() {
    return {
      arrowLeft,
      arrowRight,
      // carousel settings
      settings: {
        itemsToShow: 1,
        snapAlign: 'start',
      },
      linkArrow,
      images: [y1, y2, y3, y4, y5],
      ins: [],
    };
  },
  created() {
    const filter = { order: 'updated_at desc' };
    getInstituteList({ filter }).then((response) => {
      this.ins = response;
      // this.listLoading = false
    });
  },
  mounted() {
    const settings = {
      className: 'os-theme-dark',
      sizeAutoCapable: true,
      paddingAbsolute: true,
      overflowBehavior: {
        x: 'scroll',
        y: 'hidden',
      },
      scrollbars: {
        clickScrolling: true,
        visibility: 'auto',
      },
      callbacks: {
        //   onScroll() {
        //     if (this.scroll().position.x === 0) {
        //       cxt.showLeftFade = false;
        //       document.getElementById('news').classList.remove('left-fade');
        //     } else {
        //       document.getElementById('news').classList.add('left-fade');
        //       cxt.showLeftFade = true;
        //     }
        //   },
      },
    };
    OverlayScrollbars(document.querySelector('.institutes-wrapper'), settings);
  },
};
</script>

<style lang="stylus" scoped>
#features, #institutes
  position: relative;

.features-wrapper, .institutes-wrapper
  padding-bottom: 24px;
  white-space: nowrap;

.features-unit
  width: 420px;
  height: 400px;
  overflow: hidden;
  white-space: normal;

.institutes-unit
  width: 360px;
  white-space: normal;

@media screen and (min-width: 576px)
  .institutes-unit
    width: 360px;
    height: 460px;
    overflow: hidden;

@media screen and (max-width: 575.7px)
  .features-unit, .institutes-unit
    width: 100%;
</style>
